import { Link as LinkIcon } from '@material-ui/icons';
import React from 'react';
import styled, { css } from 'styled-components';

import { IconButton } from '@workboard/wobo-ui';

import { useTranslation } from 'react-i18next';
import useCopyToClipboard from '../hooks/useCopyToClipboard';
import { CopyProps } from '../../types/teams.types';

interface IIcon {
  $width?: number;
  $height?: number;
}

const ClipButton = styled(IconButton)<IIcon>`
  ${({ $width, $height }) =>
    $width &&
    $height &&
    css`
      width: ${$width}px;
      height: ${$height}px;
    `}
  opacity: 0;
  transition-property: background-color, color, opacity, visibility;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
  background: inherit;
  span {
    height: 20px;
  }
  svg {
    width: 20px;
    height: 20px;
  }
  &:hover,
  &:focus-within,
  &:focus {
    background: #ebeef2;
  }
`;

const CopyClip = ({ pathname, width, height }: CopyProps): JSX.Element => {
  const { t } = useTranslation();
  const [copy] = useCopyToClipboard();

  const copyHandle = async (): Promise<void> => {
    const res = await copy(pathname);

    if (res) {
      toastr.success(t('Link copied to your clipboard.'));
    } else {
      toastr.error(t('Clipboard not supported.'));
    }
  };

  return (
    <ClipButton
      compact
      $width={width}
      $height={height}
      onClick={copyHandle}
      title={t('Copy link')}
    >
      <LinkIcon />
    </ClipButton>
  );
};

export default CopyClip;
